import React from "react";
import ReactModal from "react-modal";
import {PiX} from "react-icons/pi";
import {useSearchDowntimeActJournalPageQuery} from "../../../../store/backend-api/backend.api";
import {DowntimeActDescription} from "./downtime-act-description/DowntimeActDescription";

interface Props {
    documentNumber: number;
    productionStageId: number | null;
    onModalClose: () => void;
}

export const ProductionStageDowntimeActModal = ({onModalClose, productionStageId, documentNumber}: Props) => {
    const {
        data,
        isSuccess
    } = useSearchDowntimeActJournalPageQuery({ productionStageId: [productionStageId!], productionOrderDocumentNumber: [documentNumber] });

    ReactModal.defaultStyles = {
        overlay: {
            ...ReactModal.defaultStyles.overlay,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            zIndex: 100,
        },
        content: {
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px',
            maxHeight: "90%",
            overflowX: 'auto',
            overflowY: 'auto',
        }
    }

    if (!isSuccess) {
        return null
    }

    return (
        <ReactModal isOpen={typeof productionStageId === 'number'}
                    onRequestClose={onModalClose}>
            <div className="flex flex-row justify-between gap-x-5">
                <p className="font-light text-base -mt-2">Причина простоя</p>
                <button type={"button"}
                        title="Закрыть"
                        onClick={onModalClose}
                        className="-mr-1 -mt-2 text-black/[.30] rounded-[5px]">
                    <PiX className="h-5 w-5"/>
                </button>
            </div>
            <div className='flex flex-col gap-y-1.5 text-sm font-light mt-2'>
                {data!.rows.map((act) =>
                    <DowntimeActDescription downtimeAct={act} />)}
                {!data!.rows.length && 'Нет актов простоя'}
            </div>
        </ReactModal>
    );
};